export default __webpack_public_path__ + "images/stripe-payment-element/cartes-bancaires-0b52b6d6342ea2ee6cb8b70a888268b2.svg";